// extracted by mini-css-extract-plugin
module.exports = {"type":"type__25E9A","label":"label__3J1U_"};